<template>
  <div v-show="isShowComponent" class="nav-sections" :class="{ 'desktop': $device.isDesktop }">
    <ClientOnly>
      <SkeletonNavSections v-if="isShowSkeleton" :error="get_sectionList.error" />
    </ClientOnly>

    <div
      v-swiper:slider="$options.static.swiperOption"
      class="nav-sections__wrapper swiper"
    >
      <div class="nav-sections__list swiper-wrapper">
        <div
          v-for="link in sectionList"
          :key="link.id"
          class="nav-sections__item swiper-slide"
        >
          <NuxtLink
            :to="localePath(`/${link.term}`).replace(/\/$/, '')"
            class="category-item"
            :data-id="`category-link-${link.term}`"
          >
            <UiText
              font="components-card-title"
              bold
              class="category-item__text"
              :class="{ 'dot' : link.term === ENUM_CATEGORY.LIVE.TERM }"
              :text="link.name"
            />

            <div class="category-item__img-wrap">
              <img
                :src="link.iconUrl"
                class="category-item__img"
                :alt="link.name"
                width="120"
                height="120"
                :title="link.name"
              />
            </div>
          </NuxtLink>
        </div>
      </div>
    </div>

    <div class="nav-sections__thumbs-wrapper">
      <div
        v-for="(item, index) in sectionList"
        :key="index"
        class="nav-sections__thumbs-item"
        :class="{ 'active': activeIndex === index }"
        @click="slideTo(index, item.term)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import SkeletonNavSections from '~/components/Lobby/Skeletons/SkeletonNavSections'
import { PARAM_PAGE, ENUM_CATEGORY } from '@/components/Lobby/enum.js'
import { scrollToUnvisibleSlide } from '~/util/helpers/sliderHelper'
import { getLangText } from '@/components/Lobby/helpers.js'

const swiperOption = {
  slidesPerView: 'auto',
  freeMode: true,
  centerInsufficientSlides: true,
  watchOverflow: true,
  shortSwipes: true,
  preventClicks: true,
  preventClicksPropagation: false,
  threshold: 12,
}

export default {
  name: 'NavSectionsInner',
  components: {
    SkeletonNavSections,
  },
  static: {
    swiperOption,
  },
  data() {
    return {
      isShowComponent: true,
      ENUM_CATEGORY,
      isLocked: true,
    }
  },
  async fetch() {
    await this.fetch_sectionList()

    this.checkRouteExists()
  },
  computed: {
    ...mapGetters('lobby', ['get_sectionList']),
    ...mapGetters('user', ['isLoggedIn']),
    sectionList() {
      const list = this.get_sectionList.data
      if (!Array.isArray(list)) return []

      return list.map((el, i) => {
        return {
          ...el,
          iconUrl: `${this.$config.cloudUrl}${el.iconUrl}`,
          name: getLangText(el.nameUa, el.nameRu, this.$i18n),
        }
      })
    },
    isShowSkeleton() {
      return (this.get_sectionList.isLoading || this.get_sectionList.error) && !this.sectionList.length
    },
    activeIndex() {
      return this.sectionList.findIndex((el) => {
        return this.$route.params[PARAM_PAGE] === el.term
      })
    },
  },
  watch: {
    $route(newVAl, oldVal) {
      if (!newVAl.params[PARAM_PAGE] || newVAl.path === oldVal.path) {
        return
      }

      this.checkRouteExists()
    },
    isLoggedIn() {
      this.fetch_sectionList()
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.scrollIntoView()

      this.slider?.on('update', (slider) => {
        this.scrollIntoView()
        this.isLocked = slider.isLocked
      })
      this.isLocked = this.slider?.isLocked
    })
  },
  methods: {
    ...mapActions('lobby', ['fetch_sectionList']),
    slideTo(index, term) {
      this.slider.slideTo(index)
      this.$router.push(this.localePath(`/${term}`).replace(/\/$/, ''))
    },
    scrollIntoView() {
      const activeIndex = this.sectionList.findIndex((el) => {
        return this.$route.params[PARAM_PAGE] === el.term
      })

      scrollToUnvisibleSlide(activeIndex, this.slider)
    },
    checkRouteExists() {
      const staticCategory = [
        ENUM_CATEGORY.FAVOURITES.TERM,
        ENUM_CATEGORY.LAST.TERM,
      ]

      const isRouteExists = this.sectionList.find((section) => this.$route.params[PARAM_PAGE] === section.term)
      const isReservedHiddenRoute = staticCategory.includes(this.$route.params[PARAM_PAGE])

      if (isRouteExists || isReservedHiddenRoute) {
        this.isShowComponent = true
      }
      else {
        this.$nuxt.error({ statusCode: 404, message: 'Page not found' })
        this.isShowComponent = false
      }
    },
  },
}
</script>

<style lang="scss" src="./style.scss" scoped></style>
